import { render, staticRenderFns } from "./BillingSettings.vue?vue&type=template&id=39a51a54&scoped=true"
import script from "./BillingSettings.vue?vue&type=script&lang=js"
export * from "./BillingSettings.vue?vue&type=script&lang=js"
import style0 from "./BillingSettings.vue?vue&type=style&index=0&id=39a51a54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a51a54",
  null
  
)

export default component.exports